const { CircularProgress, Alert, useTheme } =  require("@mui/material")

const { Box } = require("@mui/system")

const { styled } = require('@mui/material/styles');
const {Tooltip} = require("@mui/material");
const { tooltipClasses } = require('@mui/material/Tooltip');

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const { useState } = require("react");
const { IconButton, Snackbar } = require("@mui/material");
const ShareIcon = require("@mui/icons-material/Share");

export const CopyToClipboardButton = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  return (
    <>
      <IconButton onClick={handleClick} color="primary">
        <ShareIcon />
      </IconButton>
      <Snackbar
        message="Copied to clibboard"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        open={open}
      />
    </>
  );
};

export const  GradientCircularProgress = () =>{
    const theme = useTheme()
  

  return (
    <>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={theme.palette.primary.light} />
            <stop offset="100%" stopColor={theme.palette.primary.light} />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
    </>
  );
}

export const ProfileLayoutHead = ({boxObj}) => {
    return (
        <Box sx={{ bgcolor: 'success.main', color: 'success.contrastText', p: .05,mr: 1, display: 'inline-block',boxShadow: 1  }}>
          {boxObj}
        </Box>
    )
  }
export const ProfileLayoutSecond = ({boxObj}) => {
    return (
        <Box sx={{bgcolor: 'info.main', color: 'info.contrastText', p: .05, display: 'inline-block',boxShadow: 1  }}>
          {boxObj}\
        </Box>
    )
  }
  export const ProfileLayoutSecondText = ({boxObj}) => {
    return (
        <Box
                  component="div"
                  sx={{
                    display: 'inline',
                    p: .05,
                    height: 1,
                    pl: .6,
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(16, 16, 16, 0.5)' : 'rgba(255, 255, 255, 0.5)'),
                    // color: (theme) =>
                    //   theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                    border: '1px solid',
                    borderColor: (theme) =>
                      theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                    borderRadius: 4,
                    borderStartStartRadius: 8,
                    borderTopLeftRadius: 8,
                    borderStartEndRadius: 8,
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    boxShadow: 1 
                  }}
                >
                    {boxObj}
        </Box>
    )
  }

  export const maskEmail =  ({email}) => {
    if (!email || !email.includes("@")) {
      throw new Error("Invalid email format");
  }

  const emailParts = email.split("@");
  const username = emailParts[0];
  const domain = emailParts[1];

  // Mask the username: keep the first 3 characters, and show 2 characters after each dot
  let maskedUsername = "";
  const usernameParts = username.split(".");
  usernameParts.forEach((part, index) => {
      if (index === 0) {
          // Mask the first part, showing the first 3 characters
          maskedUsername += part.slice(0, 3) + "*".repeat(Math.max(0, part.length - 3));
      } else {
          // Show the first 2 characters of subsequent parts, masking the rest
          maskedUsername += "." + part.slice(0, 2) + "*".repeat(Math.max(0, part.length - 2));
      }
  });

  // Mask the domain: keep the first letter of the domain name and mask the rest
  const domainParts = domain.split(".");
  if (domainParts.length < 2) {
      throw new Error("Invalid email domain format");
  }

  const maskedDomain =
      domainParts[0].slice(0, 1) +
      "*".repeat(Math.max(0, domainParts[0].length - 1)) +
      "." +
      domainParts.slice(1).join(".");

  return maskedUsername + "@" + maskedDomain;
}